// @ts-ignore
import debounce from 'lodash/debounce';

export class TimelineControls {
    private controlsContainer: HTMLElement;
    private controlsList: HTMLElement;
    private rangeInput: HTMLInputElement;
    private mobileTrigger: HTMLElement;
    private links: NodeListOf<HTMLAnchorElement>;
    private sections: Array<HTMLElement>;
    private observer: IntersectionObserver;

    constructor(controls) {
        this.controlsContainer = controls;
        this.controlsList = controls.querySelector('[data-tl-ctrl-list]');
        this.rangeInput = controls.querySelector('[data-tl-ctrl-slider-input]');
        this.mobileTrigger = controls.querySelector('[data-tl-ctrl-mobile-trigger]');
        this.links = this.controlsList.querySelectorAll('[href^="#"]');
        this.sections = this.findSections();
        this.addObservers();
        this.addEventListeners();
    }

    private addObservers() {
        this.observer = new IntersectionObserver((entries, observer) => {
            let activeLink = null;

            entries.forEach((entry) => {
                if (!entry.isIntersecting || this.rangeInput.dataset.update === 'true') {
                    return;
                }

                activeLink = this.controlsList.querySelector('[href="#' + entry.target.id + '"]');

                // update range slider
                let currentElement = entry.target as HTMLElement;
                this.rangeInput.value = currentElement.dataset.title
                this.updateRangeSliderBackground(currentElement.dataset.title);
            });

            if (activeLink != null) {
                this.links.forEach((link) => {
                    link.classList.remove('is-active');
                    link.parentElement.classList.remove('is-active');
                });
                activeLink.classList.add('is-active');
                activeLink.parentElement.classList.add('is-active');
                this.mobileTrigger.innerHTML = activeLink.title;
            }


        }, {
            rootMargin: "-" + this.controlsContainer.getBoundingClientRect().height + "px 0% " + ((window.innerHeight * -1) + this.controlsContainer.getBoundingClientRect().height) + "px 0%",
        });

        this.sections.forEach((section) => {
            this.observer.observe(section);
        });
    }

    private removeObservers() {
        this.observer.disconnect();
    }

    private findSections() {
        let sections = [];
        this.links.forEach((link) => {
            sections.push(document.querySelector(link.getAttribute('href')));
        });

        return sections;
    }

    private addEventListeners() {
        window.addEventListener('resize', debounce(() => {
            this.removeObservers();
            this.addObservers();
        }, 100));

        this.addEventListenerForDropdown();
        this.addEventListenerForRangeSlider();
    }

    private addEventListenerForDropdown() {
        this.mobileTrigger.addEventListener('click', () => {
            this.mobileTrigger.classList.toggle('is-active');
            this.controlsList.classList.toggle('is-active');
        });

        this.links.forEach((link) => {
            link.addEventListener('click', () => {
                this.mobileTrigger.classList.remove('is-active');
                this.controlsList.classList.remove('is-active');
            });
        });
    }

    private addEventListenerForRangeSlider() {
        document.addEventListener('scrollend', (event) => {
            this.rangeInput.dataset.update = 'false';
        });

        this.rangeInput.addEventListener('change', (event) => {
            const target = event.target as HTMLInputElement;
            const targetValue = target.value;

            this.rangeInput.dataset.update = 'true';

            this.links.forEach((link) => {
                if (targetValue === link.title) {
                    location.href = link.href;
                }
            });
        });

        this.rangeInput.addEventListener('input', (event) => {
            const target = event.target as HTMLInputElement;

            this.updateRangeSliderBackground(target.value);
        });
    }

    /**
     * We have to factor in an offset to keep the progress bar inline with the slider handle.
     * @param targetValue
     * @private
     */
    private updateRangeSliderBackground(targetValue) {
        //@ts-ignore
        const gradientPercentage = (targetValue - this.rangeInput.min) / (this.rangeInput.max - this.rangeInput.min) * 100;
        let gradientStart = 1;

        if (gradientPercentage === 0) {
            // start with +1% at min value
            gradientStart = 1
        } else if (gradientPercentage === 100) {
            gradientStart = 100
        } else if (gradientPercentage < 50) {
            // +1%, otherwise the progress bar is too short
            gradientStart = Math.min(100, ((gradientPercentage) + 1))
        } else {
            // -1%, otherwise the progress bar is too long
            gradientStart = Math.min(100, ((gradientPercentage) - 1))
        }

        this.rangeInput.style.setProperty('--ffn-rangeslider-gradient-start', gradientStart  + '%');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('[data-tl-ctrl-container]').forEach((controlsContainer) => {
        new TimelineControls(controlsContainer);
    });
});
